/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class InterfaceMonitoringReportService {
  private interfaceMonitoringLogURL: string = environment.host + '/interfaceMonitoringLogs/filter';
  private interfaceMonitoringLogReportUrl: string = environment.host + '/report/interfaceMonitoringLogReport';
  private retryUrl: string = environment.host + '/intefaceMonitoring/retry';
  private reprocessUrl: string = environment.host + '/intefaceMonitoring/retry';
  public invokeCancelRequest: Observable<any>;
  public isCancelRequest: Subject<any>;

  constructor(private http: HttpClient) {
    this.isCancelRequest = new Subject<boolean>();
    this.invokeCancelRequest = this.isCancelRequest.asObservable();
  }

  public cancelRequest(val: any) {
    this.isCancelRequest.next(val);
  }

  public getAllInterfaceMonitoringLogs(payload: any, inboundStartRecord: any, outboundStartRecord: any, recordsSize: any) {
    const filterURL =
      this.interfaceMonitoringLogURL +
      '?inboundPageMaxId=' +
      inboundStartRecord +
      '&outboundPageMaxId=' +
      outboundStartRecord +
      '&size=' +
      recordsSize;
    return this.http.post(filterURL, payload).pipe(map((response) => response));
  }

  public getReportDetails() {
    const interfaceMonitoringReportUrl = this.interfaceMonitoringLogReportUrl;
    return this.http.get(interfaceMonitoringReportUrl).toPromise();
  }

  public retryInterfaceMonitoringLog(payload: any) {
    return this.http.post(this.retryUrl.toString(), payload).toPromise();
  }

  public reProcessInterfaceMonitoringLog(payload: any) {
    return this.http.post(this.reprocessUrl.toString(), payload).toPromise();
  }

  public getInboundAndIntegrationRequestPayloadFile(requestId: string, volumeDirection: string): Observable<Blob> {
    const url = environment.host + '/interfaceMonitoringLogs/requestPayload/download?id=' + requestId + '&volumeDirection=' + volumeDirection;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json; charset=utf-8');
    return this.http.get(url, { headers: headers, responseType: 'blob' }).pipe(
      map((res) => {
        return new Blob([res], { type: 'application/json; charset=utf-8' });
      })
    );
  }
}
